import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-amr-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const id = btn.dataset.amrAdd;
  btn.disabled = true;
  const label = btn.textContent;
  btn.textContent = 'Adding...';
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((c) => c.dataset.sectionId).filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: [{ merchandiseId: id, quantity: 1 }],
    promise: deferred.promise,
  }));
  try {
    const res = await fetch(window.Shopify?.routes?.root ? `${Shopify.routes.root}cart/add.js` : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1, properties: { _amr_upsell: btn.closest('.cart-drawer__items') ? 'drawer' : 'pdp' } }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || 'Add failed');
    const cart = await (await fetch('/cart.js')).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, sections: data.sections, source: 'amorin-pair', itemCount: 1, didError: false },
    });
    btn.textContent = 'Added';
    if (!btn.closest('.cart-drawer__items')) setTimeout(() => document.querySelector('[on\\:click="#cart-drawer/toggle"]')?.click(), 350);
  } catch (err) {
    deferred.reject(err);
    btn.textContent = label;
    btn.disabled = false;
    window.location.href = `/cart/add?id=${id}&quantity=1`;
  }
});
